export class ThirdParty {
  name: string;
  id: any;
  constructor() {
    this.name = "";
    this.id = "";
  }
}
